import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GameShowService } from '../../services/game-show.service';
import { ShowArchiveService } from '../../services/show-archive.service';

@Component({
  selector: 'app-game-show-stats',
  standalone: true,
  imports: [RouterLink],
  template: `
    <section class="section page-heading premium-heading">
      <p class="eyebrow">Öffentliche Ansicht</p>
      <h1>Spielshow-Übersicht</h1>
      <p class="lead">Öffentlich sichtbar sind nur Shows, Formate und grobe Zahlen. Die Fragen-Datenbank bleibt privat und wird später nur im Creator/Admin-Bereich verwaltet.</p>
    </section>

    <section class="section stats-grid">
      <article class="card big-stat accent-card">
        <span>{{ archive.events.length }}</span>
        <p>Shows im Archiv</p>
      </article>
      <article class="card big-stat accent-card">
        <span>{{ gameShowService.gameShows.length }}</span>
        <p>geplante Formate</p>
      </article>
      <article class="card big-stat accent-card">
        <span>{{ totalPlayedQuestions }}</span>
        <p>Fragen in öffentlichen Show-Rückblicken</p>
      </article>
    </section>

    <section class="section grid two">
      <article class="card accent-card">
        <p class="tag">Privat</p>
        <h2>Fragen sind nicht öffentlich</h2>
        <p>Normale User sehen keine offene Fragenliste. Erst nach einer gespielten Show können ausgewählte Fragen, Antworten und Ergebnisse als Rückblick freigegeben werden.</p>
      </article>
      <article class="card accent-card">
        <p class="tag">Öffentlich</p>
        <h2>Shows & Ergebnisse</h2>
        <p>Öffentlich sichtbar sind Show-Titel, Datum, Format, Anzahl der Fragen, Teilnehmer und Gewinner.</p>
        <a routerLink="/spielshows" class="button primary">Zum Show-Archiv</a>
      </article>
    </section>
  `
})
export class GameShowStatsComponent {
  readonly gameShowService = inject(GameShowService);
  readonly archive = inject(ShowArchiveService);
  readonly totalPlayedQuestions = this.archive.events.reduce((sum, event) => sum + event.questionResults.length, 0);
}
